import { useCallback } from "react";
import { isBlank } from "../util/ext";
import { useNavigate, useLocation } from "react-router-dom";

export const useEditScreenClose = defaultRoute => {
  const navigate = useNavigate();
  const { state } = useLocation();

  return useCallback(() => {
    const route = isBlank(state) ? defaultRoute : state.from;
    const fullRoute =
      isBlank(state) || !!state.creatorRelative ? `/creator${route}` : route;

    navigate(fullRoute, {
      state: {
        searchState: isBlank(state) ? {} : state.searchState,
      },
    });
  }, [navigate, state, defaultRoute]);
};
